import React from "react";
import { styled } from "@mui/material/styles";

import PageSidebar from "../pageSidebar/PageSidebar";

const Root = styled("div")(({ theme }) => ({
  "&.pageWithHeaderAndSidebar": {
    width: "100%",
    height: "calc(100% - 60px)",
    display: "flex",
  },
  "&.pageWithHeader": {
    width: "100%",
    height: "calc(100% - 60px)",
  },
  "&.pageWithSidebar": {
    width: "100%",
    height: "100%",
    display: "flex",
  },
  "&.page": {
    width: "100%",
    height: "100%",
  },
}));

const PageContent = styled("div")(({ theme }) => ({
  width: "100%",
  height: "100%",
  padding: 40,
  backgroundColor: "#f8f8f8",
  overflowY: "auto",
  [theme.breakpoints.down("sm")]: {
    padding: 20,
  },
}));

const Title = styled("div")({
  color: "#000000",
  fontSize: 18,
  lineHeight: "21px",
  marginBottom: 20,
});

function PageWrapper({
  children,
  showHeader,
  showSidebar,
  title,
  showMinimizedSidebar,
}) {
  let rootClass = "page";

  if (showHeader && showSidebar) rootClass = "pageWithHeaderAndSidebar";
  else if (showHeader) rootClass = "pageWithHeader";
  else if (showSidebar) rootClass = "pageWithSidebar";

  return (
    <Root className={rootClass}>
      {(showSidebar || showHeader) && (showSidebar || showHeader) !== "page" ? (
        <>
          {(showSidebar || showHeader) && showSidebar && (
            <PageSidebar showMinimizedSidebar={showMinimizedSidebar} />
          )}
          <PageContent>
            {title && <Title>{title}</Title>}
            {children}
          </PageContent>
        </>
      ) : (
        <PageContent>
          {title && <Title>{title}</Title>}
          {children}
        </PageContent>
      )}
    </Root>
  );
}

export default PageWrapper;
